<template>
  <div class="record-box">
    <!-- 列表数据 -->
    <div class="content">
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell
          v-for="(item, i) in state.list"
          :key="i + '-list'"
          :border="false"
        >
          <template #value>
            <p>
              <span>省钱卡</span><span>{{ item.days }}天</span>
            </p>
            <p>省钱卡开通时间：{{ time(item.success_time) }}</p>
            <p>
              开通方式：
              <span v-if="item.pay_bank == 'wx'">
                <img src="../../../assets/personal/ico_wxzf.png" alt="" />
                微信支付
              </span>
              <span v-else="item.pay_bank == 'zfb'">
                <img src="../../../assets/personal/ico_zfbzf.png" alt="" />
                支付宝支付
              </span>
            </p>
            <p>付款金额：{{ item.pay_money }}</p>
          </template>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
import { reactive, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { getSavingCardBuyRecord } from "@/api/yzuser";
import { useStore } from "vuex";
import { dateMDHM, dateYMDHM } from "@/utils/date";
import { getQueryString } from "../../../utils/location";
import { setToken, getToken, removeToken } from "@/utils/auth";
import { getSuperSavingCardBuyRecord } from "../../../api/yzuser";

export default {
  name: "exchangerecord",
  setup() {
    const store = useStore();

    const router = useRouter();
    const state = reactive({
      list: [],
      loading: false,
      finished: false,
    });
    // 返回
    const onClickLeft = () => {
      router.go(-1);
    };
    // 加载数据
    onMounted(() => {
      if (getQueryString("token")) {
        setToken(getQueryString("token"));
      }
      // console.log("省钱卡领取记录页面激活-----------");
      state.list = [];
      state.loading = false;
      state.finished = false;
      pagecode = 1;
      totalpage = 1;
      onLoad();
    });

    var pagecode = 1;
    var totalpage = 1;

    const onLoad = () => {
      // 异步更新数据
      getSuperSavingCardBuyRecord({
        pagecode: pagecode,
        username: getQueryString("username"),
      }).then((response) => {
        // console.log("省钱卡领取记录数据", response);
        if (response.data.code == 1) {
          totalpage = response.data.data.total_page;
          for (let i = 0; i < response.data.data.lists.length; i++) {
            state.list.push(response.data.data.lists[i]);
          }
        }
      });
      // 加载状态结束
      state.loading = false;

      // 数据全部加载完成
      if (pagecode > totalpage) {
        state.finished = true;
      }

      pagecode++;
    };

    // 时间戳转换
    const time = computed(() => {
      return function(date) {
        return dateYMDHM(date);
      };
    });

    return {
      state,
      onClickLeft,
      onLoad,
      time,
    };
  },
};
</script>

<style scoped="scoped">
.content {
  background-color: #f7f8fa;
}
.record-content {
  height: 93vh;
  background-color: #f7f8fa;
}
.record-item {
  height: 200px;
}

.record-item > p {
  color: #787878;
  font-size: 26px;
  margin-top: 0px;
}

.top-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.top-box p:nth-of-type(2) {
  color: red;
}
.parent-box {
  padding-top: 100px;
  min-height: 100vh;
  background-color: #f7f8fa;
}

.content {
  padding: 0 32px;
  padding-top: calc(32px + constant(safe-area-inset-top));
  /* 适配安全区域 iOS < 11.2 */
  padding-top: calc(32px + env(safe-area-inset-top));
  /* 适配安全区域 iOS >= 11.2 */
  height: 100vh;
}
.van-cell__value--alone p:nth-of-type(1) {
  display: flex;
  justify-content: space-between;
}

.van-cell {
  width: 686px;
  height: 218px;
  display: block;
  background: #fff;
  border-radius: 16px;
  padding: 24px 32px 0 24px;
  font-size: 24px;
  margin-bottom: 20px;
}
.van-cell p {
  color: #333;
}
.van-cell p:nth-of-type(1) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 32px;
  color: #333;
  font-weight: 500;
}

.content ul li p:nth-of-type(2) {
  margin: 12px 0;
}

.content img {
  width: 35px;
  height: 35px;
  vertical-align: middle;
}
</style>
